export default {
  data() {
    return {
      pageParamsCopyJson: ''
    }
  },
  created() {},
  mounted: function() {
  },
  computed: {},
  methods: {
    setPageParamsCopyJson(pageParams) {
      this.pageParamsCopyJson = JSON.stringify(pageParams)
    },
    search() {
      this.pageParams.current = 1
      this.setPageParamsCopyJson(this.pageParams)
      this.loadList(JSON.parse(this.pageParamsCopyJson))
    },
    sortChange(column, prop, order) {
      this.pageParams.sortField = prop
      if (order === 'ascending') {
        this.pageParams.sortOrder = 1
      } else if (order === 'descending') {
        this.pageParams.sortOrder = 0
      } else {
        delete this.pageParams.sortOrder
        delete this.pageParams.sortField
      }
      this.pageParams.current = 1
      this.loadList(this.pageParams)
    },
  }
}
